import { render, staticRenderFns } from "./BlockType12.vue?vue&type=template&id=2dc44cad&scoped=true&"
import script from "./BlockType12.vue?vue&type=script&lang=ts&"
export * from "./BlockType12.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType12.vue?vue&type=style&index=0&id=2dc44cad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc44cad",
  null
  
)

export default component.exports